/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { TeamUserAssignmentDto } from './TeamUserAssignmentDto';
import type { UserPermissionAssignmentDto } from './UserPermissionAssignmentDto';

export type CreateUserUiRequestDto = {
    authTypes: Array<'SAML2' | 'LOGIN_PASSWORD'>;
    domains?: Array<UserPermissionAssignmentDto>;
    email: string;
    name: string;
    role: CreateUserUiRequestDto.role;
    teams?: Array<TeamUserAssignmentDto>;
};

export namespace CreateUserUiRequestDto {

    export enum role {
        ADMIN = 'ADMIN',
        SYSTEM_EDITOR = 'SYSTEM_EDITOR',
        SYSTEM_VIEWER = 'SYSTEM_VIEWER',
    }


}
